let memoizedColumns = []
const WorkflowColumn = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
        {
            accessorKey: 'workflow_name',
            header: 'Workflow',
        }
    ]
    return memoizedColumns
}

export default WorkflowColumn;